document.addEventListener('variant:update', (event) => {
  const productId = event.detail?.data?.productId;
  if (!productId) return;

  const html = event.detail?.data?.html;
  if (!html) return;

  const newStatus = html.querySelector('price-tax');
  const currentStatus = document.querySelector('price-tax');
  
  currentStatus.replaceWith(newStatus);
});